// extracted by mini-css-extract-plugin
export default {"ZegoToast":"zegoToast_ZegoToast__zKpnB","content":"zegoToast_content__5Ms4l"};